<template>
  <div>
    <div class=" is-fullwidth mb-4" id="topheader">
      <form class="field has-addons" @submit.prevent="getSamples">
        <div class="control is-expanded">
          <label for="search-sample-id" style="display:none;">Sample ID</label>
          <input
            id="search-sample-id"
            v-model.trim="search_sample_id"
            class="input"
            type="text"
            placeholder="Enter sample ID"
          >
        </div>
        <div class="control">
          <button class="button is-link" type="submit">Search</button>
        </div>
      </form>
    </div>
    
    <div class="notification is-info" v-if="loading == true " style="clear:both">Searching requests ...</div>

    <div class="notification is-warning" v-if="loading == false && this.samples.length == 0 " style="clear:both">No requests can be found, please search by ID number above.</div>

    <div v-if="loading==false && this.samples.length > 0" class="mb-6" style="clear:both">
      <h2 class="title">Matching Requests</h2>
      <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
          <thead>
            <tr>
            <th>ID</th>
            <th>&nbsp;</th>
              <th>&nbsp;</th>
              
              <th>Qty</th>
              <th>Extras</th>
              <th style="display:none">Files</th>
              
              <th>Art.</th>
              <th>Digi.</th>
              <th style="display:none">Trans</th>
              <th>Gerber</th>
              <th>Sundries</th>
              <th>Makeup</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="row in samples">
            <tr  class="has-background-link-light" :key="'header' + row.id">
              <th ><router-link :to="'/samples/view/' + row.id" >{{ row.id}}</router-link></th>
                  <th colspan="9"> <span v-if="row.team_id > 0">{{ row.team_name}}</span>
                    <span v-if="row.team_id == -1">{{ row.club_name}}</span>
                    - {{  row.user_firstname }}  {{  row.user_surname }}
                  </th>
                  <th >&nbsp;</th>
                </tr>
              
              <tr v-for="(item, index) in row.items" :key="item.id">
                  <td>{{row.id}}.{{ index+1 }}</td>
                  <td>{{ item.garmentname }}</td>
                  <td>{{ item.sample_item_type_name }}</td>
                  <td>{{ item.quantity}}</td>
                  <td class="">
                    <div class="tags">
                      <span class="tag " v-if="item.embroidery==1" :class="{'is-success' : item.embroidery_completed==1}">Embroidery</span>
                      <span class="tag " v-if="item.trims==1" :class="{'is-success' : item.trims_completed==1}">Trims</span>
                      <span class="tag " v-if="item.dtf==1" :class="{'is-success' : item.dtf_completed==1}">DTF</span>
                      <span class="tag " v-if="item.silicon==1" :class="{'is-success' : item.silicon_completed==1}">Silcon</span>
                    </div>
                  </td>
                  <td style="display:none"><i class="fa fa-folder" aria-hidden="true"></i></td>
                  
                  <td><span class="button tag is-success" v-if="item.artwork_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.digital_print_completed==1">Done</span></td>
                  <td style="display:none"><span class="button tag is-success" v-if="item.trans_completed==1">Done</span></td>
                  <td><span class="button tag is-success"  v-if="item.gerber_cutting_completed==1">Done</span></td>
                  <td></td>
                  <td><span class="button tag is-light" v-if="item.sample_item_type_id ==4">N/A</span>
                    <span class="button tag is-success" v-else-if="item.makeup_completed==1">Done</span></td>
              </tr>
            
            </template>
              
          </tbody>
        </table>
    </div>
    <!-- end of new samples-->
    
    
    <div v-if="loading==false && this.samples.length > 0" class="mt-6">
      <p class="has-background-link-light">Requests showing in blue are not yet processed from incoming requests.</p>
      <p class="has-background-success-light">Requests in green have been processed and are now in production.</p>
    </div>

    
  </div>
</template>

<script>



import SampleService from '@/services/SampleService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";



export default {
  components: {
        
      },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
       orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: false,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      makeup_location_id: '',
      order_by: 'deliverydate ASC',
      samples: [],
      search_sample_id: '',
      user: []
    }
  },
   methods: {
    
    viewRequest(id)
    {
        this.$router.push("/samples/view/" + id);
    },
      async getSamples() {
        this.loading=true
       
          
        
          SampleService.searchSamples(this.accessToken, this.search_sample_id)
          .then(
            (samples => {
              this.$set(this, "samples", samples);
              this.loading=false
            }).bind(this)
          );
        
        
      },
      
   
    
  },
  computed : {
      
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           //this.getSamples()
           
        });
  },
 
  mounted() {
    //console.log(this.area.path)
      
  },
  watch: {
    
  }
}


</script>

